var map = {
	"./lonelyness-art-prize 2.png": 13125,
	"./lonelyness-art-prize 4.png": 67315,
	"./lonelyness-art-prize 5.png": 28458,
	"./lonelyness-art-prize 7.png": 92824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1351;